/**
 * A short, stable id for the payment instrument a guest paid with.
 *
 * THE INTENT is Viva's token for the instrument: pay with the same card twice
 * and the same token comes back, which is what lets a guest collect points
 * with no account. That token is not available to this app yet, so this
 * derives a stand-in from what the checkout knows.
 *
 * THE CAVEAT, and it is the whole feature: a token that rotates per
 * transaction — or per device — turns every returning guest into a new one.
 * Before this is trusted, someone has to confirm which of Viva's identifiers
 * is stable across visits. The stand-in below is stable only for Blik, where
 * the code identifies the payer's bank app; the wallets have nothing to hash,
 * so they fall back to the method name and every guest paying by Apple Pay
 * shares one hash.
 */

/** Small non-cryptographic digest — this identifies, it does not protect. */
const digest = (input: string): string => {
  let hash = 0x811c9dc5;
  for (let i = 0; i < input.length; i += 1) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0).toString(16).padStart(8, "0").slice(0, 6);
};

export const paymentInstrumentHash = (
  method: string | null,
  blikCode?: string,
): string | undefined => {
  if (!method) return undefined;
  const instrument = blikCode ? `${method}:${blikCode}` : method;
  return digest(instrument);
};
